<template>
  <div id="app">
    <Banner v-show="showBanner.indexOf($route.name) === -1" />
    <van-sticky :offset-top="0">
      <Header v-show="showHeader.indexOf($route.name) === -1" />
      <Menu v-show="showBanner.indexOf($route.name) === -1" />
    </van-sticky>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <Footer v-show="['Search', 'DisclosureSearch'].indexOf($route.name) === -1" />
  </div>
</template>

<script>
import Banner from "@/components/Banner";
import Menu from "@/components/Menu";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { getConfig } from "@/api";

export default {
  name: "AppView",
  components: {
    Banner,
    Header,
    Menu,
    Footer,
  },
  mounted() {
    getConfig({
      key: "SITE_WEB_FLAG",
    }).then((res) => {
      if (res.data == 1) {
        let html_box = document.getElementById("html_box");
        html_box.style.filter = "grayscale(100%)";
      }
    });
  },
  data() {
    return {
      showBanner: [
        "Disclosure",
        "FinancialNewsInside",
        "FinancialNews",
        "Visualization",
        "Article",
        "Corporation",
        "Ipoauth",
        "Shuwen",
        "Search",
        "NewShares",
        "Picture",
        "DisclosureColumn",
        "ecosphereIns",
        "moreList",
        "Bank",
        "NotFound",
        "videoArticle",
        "DisclosureSearch",
      ],
      routerAlive: false,
      showHeader: ["Disclosure", "FinancialNews", "Visualization", "Search", "DisclosureColumn", "DisclosureSearch"],
    };
  },
  watch: {
    $route(to, from) {},
  },
};
</script>
